









import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({
  name: "textSetting",
})
export default class TextSetting extends Vue {
  private text = "";
  @Prop({ type: Object, default: {} })
  item!: any;
  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    this.text = value.text;
    console.log(this.text, "图片预览组件---", value);
  }
}
